import { WorkOrder } from '@models';

/*
 * returns yyyyMMdd_HHmmss format
 */
function getDateTimeFormat(dateTime: Date) {
  // yyyyMMDD
  const date =
    dateTime.getFullYear().toString() +
    (dateTime.getMonth() + 1).toString().padStart(2, '0') +
    dateTime.getDate().toString().padStart(2, '0');
  // HHmmss
  const time =
    dateTime.getHours().toString().padStart(2, '0') +
    dateTime.getMinutes().toString().padStart(2, '0') +
    dateTime.getSeconds().toString().padStart(2, '0');

  return `${date}_${time}`;
}

function getFilenameConvention(
  systemName: string,
  workOrder: WorkOrder,
  dateTime: Date,
  fileType: string
) {
  // prettier-ignore
  return `${systemName}-${workOrder.workOrderId}_${workOrder.operationNumber}-${getDateTimeFormat(dateTime)}.${fileType}`
}

export function renameFile(file: File, _index: number, workOrder: WorkOrder) {
  const systemName = workOrder.systemName?.replace(' ', '') ?? '';
  const fileType = file.name.split('.').pop() ?? 'jpg';

  const dateTime = new Date();

  // find first available name second by second (prevent duplicities)
  let name = getFilenameConvention(systemName, workOrder, dateTime, fileType);
  while (
    workOrder.attachments?.some((attachment) => attachment.file.name === name)
  ) {
    dateTime.setSeconds(dateTime.getSeconds() + 1);
    name = getFilenameConvention(systemName, workOrder, dateTime, fileType);
  }

  const newFile = new File([file], name, { type: file.type });

  // add file temporarily to the workOrder to prevent duplicity in case of not refreshing the page
  workOrder.attachments?.push({ file: newFile } as any);

  return newFile;
}
